

import HomeHotGames from './Home-Hot-Games';
import HomeMoreGames from './Home-More-Games';

interface Props {
    sgdList: any;
    thbList: any;
    label: any;
}

const BottomSectionCarousels = ({ sgdList, thbList, label }: Props) => {
    return (
        <div className="bottom-section-carousels-container">
            {/* <HomeHotGames /> */}
            <HomeMoreGames sgdList={sgdList} thbList={thbList} label={label} />
        </div>
    )
}

export default BottomSectionCarousels;